import { PlaceholdersId, TFComponent } from '@types';
import { MembershipCompletionTitlePlaceholder } from './membershipCompletionTitle';

export const membershipCompletionTitle: TFComponent = {
	component: MembershipCompletionTitlePlaceholder,
	id: PlaceholdersId.membershipCompletionTitle,
	name: 'membershipCompletionTitle',
};
